import { theme } from '@Guidelines/Theme/theme';
import resolveFieldVerificationPresentation from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Helpers/fieldVerificationPresentation';
import type LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { css } from '@emotion/react';
import type * as React from 'react';

const badgeStyle = (surface: string, ink: string) => css`
	display: inline-flex;
	align-items: center;
	padding: 0.375rem 0.6875rem;
	border-radius: ${theme.radii.pill};
	background-color: ${surface};
	color: ${ink};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.small};
	font-weight: ${theme.fontWeights.medium};
	white-space: nowrap;
`;

type Props = {
	readonly status: LabeledValueView;
};

/**
 * The single component of a field's own state — the label comes from the server, never translated;
 * the tint comes from the shared presentation table. Employed by `FieldCard` and `SourcePanelSidebar`
 * alike, so the two surfaces never disagree on what a state looks like.
 */
const FieldVerificationBadge: React.FC<Props> = ({ status }) => {
	const presentation = resolveFieldVerificationPresentation(status.value);

	return <span css={badgeStyle(presentation.badgeSurface, presentation.badgeInk)}>{status.label}</span>;
};

export default FieldVerificationBadge;
